import { Field, ObjectField, ShapeForm } from '@takeshape/shape-form';
import { LoaderButton } from '../../../../common/daisy/loader-button.tsx';
import type { ToolEditorProps } from './tool-editor-hook.js';

const metadataFieldOrder = ['name', 'visibility', 'description'];
const optimizeResponseConfig = { title: 'Response Optimization' };

export function ToolEditor(props: ToolEditorProps) {
  const { store, widgets, handleSubmit, hasPendingChanges, isDisabled } = props;

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <h4 className="font-semibold text-md mb-3">Edit Tool</h4>
      <ShapeForm store={store} widgets={widgets} className="flex flex-1 min-h-0 gap-6">
        {/* Left column: metadata + execution settings */}
        <div className="w-[35%] shrink-0 flex flex-col">
          <ObjectField path="" order={metadataFieldOrder} />
          <div className="mt-4 space-y-4">
            <Field path="execution.path" />
            <Field path="execution.optimizeResponse" config={optimizeResponseConfig} />
          </div>
        </div>
        {/* Right column: query editor (full height) */}
        <div className="flex-1 flex flex-col min-h-0 min-w-0">
          <Field
            path="execution.query"
            className="flex flex-col flex-1 min-h-0 [&>fieldset]:flex [&>fieldset]:flex-col [&>fieldset]:flex-1 [&>fieldset]:min-h-0"
          />
        </div>
      </ShapeForm>
      <div className="flex justify-end pt-3">
        <LoaderButton
          loading={hasPendingChanges}
          className="btn btn-sm btn-primary"
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          {hasPendingChanges ? 'Saving' : 'Save'}
        </LoaderButton>
      </div>
    </div>
  );
}
